export default __webpack_public_path__ + "static/media/image 7.761c3379e861a1cb1cd88e606c96436d.svg";